// Editable site content for KP Capital — Private Trading Society

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_kp-mentorship/artifacts/s2z4j8qy_WhatsApp%20Image%202026-05-21%20at%205.18.59%20PM.jpeg";

export const HERO_BG =
  "https://static.prod-images.emergentagent.com/jobs/b8124ee1-399e-4d94-bcb5-39441104277f/images/04741a949490cd660ab7d71b3eaa0856af3fbde6441edfbb95cf25def29b6a79.png";

export const MENTORSHIP_BG =
  "https://static.prod-images.emergentagent.com/jobs/b8124ee1-399e-4d94-bcb5-39441104277f/images/666fa880e5bbd3b103e72a0d78a82f6464719a618156beb827c9b92ecb9ccf24.png";

export const CONSULT_BG =
  "https://static.prod-images.emergentagent.com/jobs/b8124ee1-399e-4d94-bcb5-39441104277f/images/2c860a50c6e9dd3d7b0bd7a0155e6838ac38a957483dd399f3e06c90dfe01a9c.png";

export const NAV_LINKS = [
  { label: "Approach", href: "#approach" },
  { label: "About", href: "#about" },
  { label: "Mentees", href: "#testimonials" },
  { label: "Insights", href: "#insights" },
  { label: "FAQ", href: "#faq" },
];

export const STATS = [
  { value: "1:1", label: "Format. No groups. No signals." },
];

export const PILLARS = [
  {
    n: "01",
    title: "Identity",
    body:
      "Most traders break before their strategy does. We rebuild the operator behind the screen — values, role, narrative — so discipline is not a daily fight.",
  },
  {
    n: "02",
    title: "Emotional Architecture",
    body:
      "Fear, greed, revenge, hope. We map your specific triggers and engineer the rituals, constraints and recovery loops that neutralise them at the source.",
  },
  {
    n: "03",
    title: "Decision Quality",
    body:
      "Outcome bias is the silent killer of capital. You will learn to grade decisions, not results — and to compound process, not luck.",
  },
  {
    n: "04",
    title: "Risk & Rhythm",
    body:
      "Sizing, drawdown protocols, session cadence, time off. The unglamorous infrastructure of every trader who survives the next decade.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Honestly didn't think I needed this. I had a strategy that worked. The problem was me, not the system, and I couldn't see it until KP made me look. First month was uncomfortable. Six months in, I'm a different trader.",
    name: "M. Calder",
    detail: "Independent FX trader — London",
  },
  {
    quote:
      "Was sceptical at first, won't lie. I'd done the courses, the journals, the affirmations stuff. None of it stuck. KP just kept asking better questions than I was asking myself. Months later I'm still using things he said in week two.",
    name: "S. Ortega",
    detail: "Personal funds trader — Madrid",
  },
  {
    quote:
      "I came in thinking we'd talk about setups. We barely did. We talked about why I size up after a loss, why I exit early on winners, why I check the chart at 2am. That's the work nobody else was willing to do with me.",
    name: "R. Mensah",
    detail: "Futures, 9 years trading",
  },
];

export const INSIGHTS = [
  {
    kicker: "Essay 01",
    title: "Discipline is a structure, not a feeling.",
    body:
      "If your edge depends on being inspired, motivated or composed every session, you do not have an edge — you have a mood.",
  },
  {
    kicker: "Essay 02",
    title: "The cost of one untrained reaction.",
    body:
      "Revenge trades, oversized entries, abandoned plans. Every meaningful drawdown is a psychology bill arriving late.",
  },
  {
    kicker: "Essay 03",
    title: "Why we refuse to publish signals.",
    body:
      "A signal solves a single trade. A trained operator solves the next ten thousand. We are not interested in the former.",
  },
];

export const FAQS = [
  {
    q: "Is this a signal service or a course?",
    a:
      "Neither. KP Capital is a 1-on-1 private mentorship focused exclusively on trading psychology. No signals, no group chats, no recorded modules.",
  },
  {
    q: "Who is this for?",
    a:
      "Serious, already-active traders who have a method but keep sabotaging it — discretionary, algorithmic, prop, retail. If you have never traded, this is not for you yet.",
  },
  {
    q: "What does a typical engagement look like?",
    a:
      "Weekly private sessions, structured journaling protocols, between-session reviews, and direct access between sessions. Engagements run in 8 or 12 week blocks.",
  },
  {
    q: "Will you guarantee profitability?",
    a:
      "No serious mentor can. We guarantee process, honesty, and the work. The market remains the only arbiter of the result.",
  },
  {
    q: "How is the free consultation different from the mentorship?",
    a:
      "The consultation is a 30-minute call to determine fit — both ways. There is no pitch and no obligation. Applications are reviewed personally by KP.",
  },
];
